import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-card-info-entregas',
    templateUrl: './card-info-entregas.component.html',
    styleUrls: ['./card-info-entregas.component.css']
})
export class CardInfoEntregasComponent {
  @Input() titulo: String = '';
  @Input() quantidade: number = 0;
  @Input() icone: String = '';
}
